var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMove = function SvgMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h34v34H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M.879 2H32v31.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    fillRule: "nonzero",
    d: "M3 2h29v29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0-5.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-5.25 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM27 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-5.25 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-5.25 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    fill: "#545454"
  }))));
};

export default SvgMove;